export enum OrderShipmentEnum{
    All="All",
    Delivery="DELIVERY",
    PreOrder="Pre-order",
    PickUp="PICK_UP"
}